import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Service } from 'app/models/services';
import { Observable, Subject, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {

  base_path = 'https://app.titv-store-api.com/';

  constructor(private http: HttpClient) { }

  private refreshData = new Subject<void>();
  
  get refreshNedeed() {
    return this.refreshData;
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private getToken(): string {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        return userObj.token || '';
      }
      return '';
    } catch {
      return '';
    }
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private getHeaders(): HttpHeaders {
    const token = this.getToken();
    
    if (token) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      });
    }
    
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // ✅ MÊME MÉTHODE QUE MAGAZINE SERVICE
  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Une erreur est survenue';
    
    if (error.status === 403) {
      errorMessage = `Accès interdit. Token: ${this.getToken() ? 'présent' : 'absent'}`;
    } else if (error.status === 401) {
      errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
    } else {
      errorMessage = `Erreur ${error.status}: ${error.message}`;
    }
    
    console.error('Erreur ServicesService:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  // Create a new item
  createService(item: any): Observable<Service> {
    const headers = this.getHeaders();
    
    return this.http.post<Service>(
      this.base_path + 'services/add', 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Get single Service data by ID
  getService(id: any): Observable<Service> {
    const headers = this.getHeaders();
    
    return this.http.get<Service>(
      this.base_path + 'services/' + id,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Get services data
  getListService(): Observable<Service[]> {
    const headers = this.getHeaders();
    
    return this.http.get<Service[]>(
      this.base_path + 'services/all',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Update item by id
  updateService(id: any, item: any): Observable<Service> {
    const headers = this.getHeaders();
    
    return this.http.put<Service>(
      this.base_path + 'services/edit/' + id, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Delete item by id
 // services.service.ts
deleteService(id: any): Observable<string> {
    const headers = this.getHeaders();
    return this.http.delete<string>(
        this.base_path + 'services/delete/' + id,
        { 
            headers,
            responseType: 'text' as 'json'   // 👈 force text response, bypass JSON parsing
        }
    ).pipe(
        tap(() => this.refreshData.next()),
        catchError(this.handleError)
    );
}

  // services.service.ts (add this method)
updateServiceOrder(id: number, displayOrder: number): Observable<any> {
  const headers = this.getHeaders();
  return this.http.put(
    this.base_path + 'services/update-order/' + id,
    displayOrder,  // backend expects Integer directly in body
    { headers, responseType: 'text' }
  ).pipe(
    tap(() => this.refreshData.next()),
    catchError(this.handleError)
  );
}
}